/*
  Sticky columns that are taller than the viewport.
  Shifts the sticky `top` value with the scroll delta, so the column scrolls
  along with the page until its bottom (scrolling down) or its top
  (scrolling up) is reached, and then sticks there.
*/
(() => {
  const SELECTOR = '.product__column-sticky';
  const BOTTOM_OFFSET = 24;
  const mql = window.matchMedia('(min-width: 750px)');

  class StickyScroll {
    constructor(el) {
      this.el = el;
      this.top = null;
      this.lastScrollY = window.scrollY;

      this.onScroll = this.onScroll.bind(this);
      this.reset = this.reset.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.reset);
      mql.addEventListener('change', this.reset);
      new ResizeObserver(this.reset).observe(el);

      this.reset();
    }

    reset() {
      this.el.style.top = '';
      this.baseTop = parseFloat(getComputedStyle(this.el).top) || 0;
      this.update(0);
    }

    onScroll() {
      const scrollY = window.scrollY;
      const delta = scrollY - this.lastScrollY;
      this.lastScrollY = scrollY;
      this.update(delta);
    }

    update(delta) {
      const minTop = window.innerHeight - this.el.offsetHeight - BOTTOM_OFFSET;

      // Column fits into the viewport: regular sticky behaviour from the CSS
      if (!mql.matches || minTop >= this.baseTop) {
        this.top = null;
        this.el.style.top = '';
        return;
      }

      const current = this.top ?? this.baseTop;
      this.top = Math.min(this.baseTop, Math.max(minTop, current - delta));
      this.el.style.top = `${this.top}px`;
    }
  }

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.stickyScroll || el.closest('.quick-add-modal')) return;
      el.stickyScroll = new StickyScroll(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
